import { AUDIO_MIME_CANDIDATES } from './constants';

export const isRecordingSupported = () =>
  typeof window !== 'undefined' &&
  typeof window.MediaRecorder !== 'undefined' &&
  Boolean(navigator.mediaDevices?.getUserMedia);

export const resolveSupportedMimeType = () => {
  if (
    typeof window === 'undefined' ||
    typeof window.MediaRecorder === 'undefined'
  ) {
    return '';
  }

  return (
    AUDIO_MIME_CANDIDATES.find((type) =>
      window.MediaRecorder.isTypeSupported(type)
    ) ?? ''
  );
};
